import styled from 'styled-components';

import { LoginText } from '@components/molecules/LoginText/LoginText';

export const BannerLoginText = styled(LoginText)`
    margin-top: 4px;
`;
